import { VueExtension } from '../../utils/extensions/vue';
import SearchBar from './searchbar.jsx';
import './searchbar.scss';

VueExtension.WithInstall(SearchBar);

export default SearchBar;
